import * as React from "react";

interface DropdownItemProps {
    children?: any,
    onClick?: () => void;
    isDownload?: boolean
    href?: string
}

const DropdownItem = ({children, onClick, href, isDownload = false}: DropdownItemProps) => {
    return <li>
        <a
            href={href ?? '#'}
            download={isDownload}
            onClick={(e) => {
                if(onClick) {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            {children}
        </a>
    </li>
}

export default DropdownItem;
